import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import { DeleteTwoTone } from '@ant-design/icons';

interface DeleteModalProps {
  visible: boolean;
  message: string;
  title?: string;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  title,
  visible,
  message,
  onClose,
  onConfirm,
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = () => {
    setLoading(true);
    onConfirm();
    setLoading(false);
  };

  const handleAfterClose = () => {
    setLoading(false);
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      centered
      maskClosable={false}
      closeIcon={null}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          type="primary"
          key="confirm"
          danger
          onClick={handleConfirm}
          loading={loading}
        >
          Yes, Delete
        </Button>,
      ]}
      afterClose={handleAfterClose}
    >
      <div className="flex flex-col items-center text-center">
        <div>
          <DeleteTwoTone twoToneColor="#eb2f96" style={{ fontSize: '80px' }} />
        </div>
        <div className="font-semibold text-xl my-2">{title}</div>
        <div>{message}</div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
